<template>
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/banner.png" alt="" />
    </div>
    <!--   快速定位服务 -->
    <BannerTxt></BannerTxt>
    <!--  企业动态 开始-->
    <div class="index_foot index_center">
      <div class="index_foot_title">
        <div class="index_foot_left_title">
          <p>企业动态</p>
          <span>Enterprise dynamics</span>
        </div>
        <div class="index_foot_right_content_icon" @click="handleClick(1)">
          <i class="el-icon-right"></i>
        </div>
      </div>
      <div class="index_foot_left_content" v-for="item in newsList" :key="item.id">
        <img @click="handleClick2(item.id)" :src="item.imageUrl" alt="" />

        <div class="index_foot_left_content_date">
          <div class="index_foot_left_content_date_day">{{ item.day }}</div>
          <div class="index_foot_left_content_date_year">{{ item.years }}</div>
        </div>
        <div class="index_foot_right_content">
          <div class="index_foot_right_content_title">
            <span>{{ item.title }}</span>
          </div>
          <div class="index_foot_right_content_text">
            <p v-html="item.summary"></p>
          </div>
          <div class="index_foot_right_content_bottom"></div>
        </div>
      </div>
    </div>

    <!--服务-->
    <div class="index_foot_bottom index_center">
      <div class="index_foot_bottom_title">
        <div class="index_foot_bottom_title_text">
          <p>服务范围</p>
          <span>Scope Of Service</span>
        </div>
        <div class="index_foot_right_content_icon" @click="handleClick(2)">
          <i class="el-icon-right"></i>
        </div>
      </div>
      <div class="index_foot_bottom_item">
        <div class="index_foot_bottom_img" v-for="(item, index) in serviceTypeList" @click="openInformation(index)"
          :key="index">
          <div class="index_foot_bottom_img_text">{{ item.serviceType }}</div>
          <img :src="item.imageUrl" alt="" mode="aspectFit" />
        </div>
      </div>
    </div>

    <!--    精彩案例 开始-->
    <div class="index_goodcase index_center">
      <div class="index_goodcase_title">
        <div class="index_goodcase_title_text">
          <p>精彩案例</p>
          <span>Wonderful case</span>
        </div>
        <div class="index_foot_right_content_icon" @click="handleClick(3)">
          <i class="el-icon-right"></i>
        </div>
      </div>
      <div class="index_goodcase_img">
        <div :class="index % 2 == 0
          ? 'index_goodcase_imgItem'
          : 'index_goodcase_imgItemReverse'
          " v-for="(item, index) in productList" :key="index">
          <div class="index_goodcase_imgItem_text">
            <p>{{ item.title }}</p>
            <span>{{ item.summary }}</span>
          </div>
          <img @click="handleCase(item.id, 1)" :src="item.imageUrl" alt="" />
        </div>
      </div>
    </div>
    <!--    精彩案例 结束-->
    <!--    合作伙伴 开始-->
    <div class="index_partners index_center">
      <div class="index_partners_title">
        <div class="index_partners_title_text">
          <p>合作伙伴</p>
          <span>Cooperative Partner</span>
        </div>
      </div>
      <div class="index_partners_img">
        <div class="index_partners_imgSrc" v-for="item in partnerList" :key="item.id">
          <img :src="item.banner" alt="" />
        </div>
      </div>
    </div>
    <submit-from></submit-from>
    <Foot></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";

import BannerTxt from "./components/BannerTxt";
import SubmitFrom from "./components/SubmitFrom";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  getProductList,
  getPartnerAllListApi,
  getServiceTypeApi,
  homePageGetNewsList,
} from "@/api/index";

export default {
  components: {
    Nav,
    Foot,
    BannerTxt,
    swiper,
    swiperSlide,
    SubmitFrom,
  },
  name: "Index",
  data() {
    return {
      newsList: [],
      partnerList: [],
      serviceTypeList: [],
      productList: [],
      newsLists: [],
      pageNum: 1,
      pageSize: 4,
      indexImg: "",
      indexIntro: "",
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
    };
  },
  mounted() {
    sessionStorage.setItem("num", 1);
    this.$cookies.set("tabbar", 0);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
    // 获取公司动态
    this.getNewsList();
    this.getPartnerAllList();
    this.getServiceType();
    this.getProductList();
  },
  //销毁前
  beforeDestroy() {
    sessionStorage.setItem("num", 0);
  },
  methods: {
    //获取精彩案例
    getProductList() {
      getProductList().then((res) => {
        // console.log("精彩案例", res);
        res.data.forEach((item) => {
          if (item.showIndexStatus == 0) {
            this.productList.push(item);
          }
        });
      });
    },
    //获取服务类型
    getServiceType() {
      getServiceTypeApi().then((res) => {
        // console.log("服务范围", res);
        this.serviceTypeList = res.data;
      });
    },
    //企业动态列表
    getNewsList() {
      homePageGetNewsList().then((res) => {
        // console.log("企业动态", res);
        res.data.forEach((item) => {
          if (item.showIndexStatus == 0) {
            this.newsList.push(item);
          }
        });
      });
    },
    //获取合作伙伴
    getPartnerAllList() {
      var data = {
        pageNumber: 1,
        pageSize: 10,
      };
      getPartnerAllListApi(data).then((res) => {
        this.partnerList = res.data.list;
      });
    },
    // 打开技术服务
    openInformation(index) {
      console.log(index);
      this.$router.push({ path: "/service", query: { index: index } });
    },
    // from 表单
    onSubmit() {
      console.log("submit!");
    },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 案例详情
    handleCase(id) {
      this.$router.push({
        path: "./ProductCaseDetail",
        name: "ProductCaseDetail",
        query: {
          id: id,
          type: 1,
        },
      });
      window.scrollTo(0, 0);
    },
    // 跳转到动态详情页面
    handleClick(id) {
      if (id == 1) {
        this.$router.push("/ParkOverview");
      }
      if (id == 2) {
        this.$router.push("/service");
      }
      if (id == 3) {
        this.$router.push("/ParkKeeper");
      }

      window.scrollTo(0, 0);
    },
    handleClick2(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 4,
        },
      });
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 1200px;
  margin: 0 auto;
  /*background-color: #ffffff;*/
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.index_title {
  width: 100%;
}

.index_title p {
  font-size: 28px;
}

.active {
  background: #1b63a7;
  color: white !important;
}

.index_title div {
  text-indent: 1em;
  font-size: 14px;
  color: #101010;
  font-family: "SourceHanSansSC-regular";
}

.index_foot {
  margin-top: 50px;
}

.index_foot_title {
  display: flex;
  justify-content: space-between;
  /*padding-bottom: 25px;*/
  padding: 60px 0 30px 0;
}

.index_foot_left_title p {
  font-size: 26px;
  color: #333333;
}

.index_foot_left_title span {
  color: #333333;
  font-size: 14px;
}

.index_foot_right {
  border-bottom: 5px solid #2968bd;
  padding-top: 15px;
  cursor: pointer;
}

.index_foot_left_content {
  border-top: 1px solid #e5e5e5;
  padding-top: 25px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding-bottom: 24px;
  height: 200px;
}

.index_foot_left_content img {
  width: 380px;
  height: 200px;
  cursor: pointer;
}

.index_foot_left_content_date {
  margin: 0 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.index_foot_left_content_date_day {
  font-size: 26px;
  padding-bottom: 28px;
  color: #666666;
  font-weight: bold;
}

.index_foot_left_content_date_year {
  font-size: 18px;
  color: #666666;
}

.index_foot_right_content {
  width: 50%;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 14px;
}

.index_foot_right_content_bottom {
  margin-top: 27px;
  display: flex;
  justify-content: flex-end;
}

div /deep/ .el-icon-right {
  width: 18px;
  height: 16px;
}

.index_foot_right_content_icon {
  color: #2968bd;
  border: 2px solid #2968bd;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  flex-flow: column-reverse;
}

.index_foot_right_content_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 30px;
}

.index_foot_right_content_text {
  width: 500px;
  font-size: 14px;
  color: #666666;
  line-height: 30px;

  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 3;*/
  /*overflow: hidden;*/
}

.index_foot_right_content_text p {
  /*超出部分用省略号表示*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.index_foot_right_one p {
  font-size: 28px;
  padding-bottom: 10px;
}

.index_foot_right_one div {
  width: 350px;
  font-size: 14px;
}

.index_foot_bottom_title {
  display: flex;
  justify-content: space-between;
  padding: 60px 0 30px 0;
}

.index_foot_bottom_title_text p {
  font-size: 26px;
  color: #333333;
  padding-bottom: 10px;
}

.index_foot_bottom_title_text span {
  font-size: 14px;
  color: #333333;
}

.index_foot_bottom_item {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e5e5e5;
  padding-top: 50px;
}

.index_foot_bottom_img {
  cursor: pointer;
  width: 260px;
  height: 360px;
  position: relative;
}

.index_foot_bottom_img img {
  width: 100%;
  /* height: 100%; */
}

.index_foot_bottom_img_text {
  position: absolute;
  background-color: #2968bd;
  opacity: 0.8;
  width: 260px;
  height: 60px;
  color: #ffffff;
  text-align: center;
  line-height: 60px;
  bottom: 0;
}

.index_goodcase_title {
  display: flex;
  justify-content: space-between;
  padding: 60px 0 30px 0;
}

.index_goodcase_title_text p {
  font-size: 26px;
  color: #333333;
  font-family: "MicrosoftYaHei";
}

.index_goodcase_title_text span {
  font-size: 14px;
  color: #333333;
  font-family: "MicrosoftYaHei";
}

.index_goodcase_img {
  flex-wrap: wrap;
  width: 105%;
  border-top: 1px solid #e5e5e5;
  padding-top: 55px;
  display: flex;
  /*justify-content: space-between;*/
}

.index_goodcase_img img {
  cursor: pointer;
  width: 280px;
  height: 194px;
}

.index_goodcase_imgItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;
  position: relative;
}

.index_goodcase_imgItem:last-child {
  margin-right: 0px;
}

.index_goodcase_imgItem::before {
  display: block;
  top: 0px;
  left: 0;
  width: 0;
  height: 4px;
  background: #2968bd;
  position: absolute;
  content: "";
  transition: all 250ms ease-in-out !important;
}

.index_goodcase_imgItem:hover::before {
  width: 118px;
}

.index_goodcase_imgItemReverse::after {
  display: block;
  bottom: 0px;
  left: 0;
  width: 0;
  height: 4px;
  background: #2968bd;
  position: absolute;
  content: "";
  transition: all 250ms ease-in-out !important;
}

.index_goodcase_imgItemReverse:hover::after {
  width: 118px;
}

.index_goodcase_imgItemReverse {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  position: relative;
  margin-right: 30px;
}

.index_goodcase_imgItem_text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /*text-align: center;*/
  width: 280px;
  height: 190px;
  background-color: #f6faff;
}

.index_goodcase_imgItem_text p {
  /*padding-top: 43px;*/
  font-size: 16px;
  color: #333333;
  font-family: "MicrosoftYaHei";
}

.index_goodcase_imgItem_text span {
  font-size: 14px;
  color: #333333;
  margin-top: 28px;
  width: 225px;
  line-height: 25px;
  /*height: 55px;*/
  font-family: "MicrosoftYaHei";
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  /*white-space: nowrap;*/

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}

.index_center_click {
  display: flex;
  justify-content: center;
  align-items: center;
  /*background-color: #999999;*/
  width: 150px;
  height: 56px;
  margin: 56px auto;
  cursor: pointer;
  border: 1px solid #999999;
  font-family: Microsoft YaHei;
}

.index_partners {
  background-color: #f9fbfe;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.index_partners_title {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  padding-top: 50px;
  padding-bottom: 30px;
  /*margin-bottom: 60px;*/
  border-bottom: 1px solid #e5e5e5;
}

.index_partners_title p {
  font-size: 26px;
  color: #333333;
}

.index_partners_title span {
  font-size: 14px;
  color: #333333;
}

.index_partners_img {
  display: flex;
  flex-wrap: wrap;

  width: 1200px;
  /*width: 60%;*/
  justify-content: space-between;
  align-items: center;
  /*padding-bottom: 40px;*/
  padding: 60px 0;
}

.index_partners_img:after {
  content: "";
  /*width: 48%;*/
  flex: auto;
}

.index_partners_imgSrc {
  display: flex;
  justify-content: center;
  /*align-items: center;*/
  width: 224px;
  height: 76px;
  box-shadow: 0px 4px 11px -2px #d2e9ff;
  /*!*box-shadow: 0px 7px 7px -7px #D2E9FF;*!*/
  margin-bottom: 40px;
  margin-left: 16px;
}

.index_partners_imgSrc img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.index_partners_imgSrc .index_partners_click {
  padding: 20px 0;
}

.information_From {
  /*padding-top: 154px;*/
  /*width: 500px;*/
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.information_From_title {
  font-size: 48px;
  padding: 30px 0;
  color: #ec59a1;
}

.information_From_tips {
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 410px;*/
  padding-top: 10px;
  color: #8c9196;
}

.information_From_tips p {
  color: #ec59a1;
}

.el_form {
  padding-left: 20%;
}

div /deep/ .el-dialog__body {
  display: flex;
  justify-content: center;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/*--------------------------*/

.index_new {
  justify-content: space-between;
}

.index_new .news {
  width: 690px;
}

.index_new .notice {
  width: 490px;
}

.index_new .news .title,
.index_service .service .title {
  font-size: 16px;
  color: #1b63a7;
  border-bottom: 2px solid #1b63a7;
  width: 200px;
  padding-bottom: 8px;
  font-weight: 400;
}

.index_new .notice .title {
  font-size: 16px;
  color: #5aa673;
  border-bottom: 2px solid #5aa673;
  width: 200px;
  padding-bottom: 8px;
}

.index_new .news .list,
.index_new .notice .list {
  width: 100%;
  /*height: 390px;*/
  background: #f6f6f6;
}

.index_new .notice .list {
  justify-content: center;
  padding-top: 10px;
  box-sizing: border-box;
}

.index_new .news .img {
  width: 200px;
  height: 100%;
  object-fit: cover;
}

.index_new .news .list .content {
  width: 490px;
  /*height: 390px;*/
  padding-top: 10px;
  box-sizing: border-box;
  align-items: center;
}

.index_new .news .list .content .more {
  width: 452px;
}

.index_new .news .list .content .more,
.index_new .notice .list .more {
  color: #1b63a7;
  font-size: 14px;
  text-align: right;
  margin-top: 20px;
}

.index_new .news .list .li,
.index_new .notice .list .li {
  height: 40px;
  width: 452px;
  line-height: 40px;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px #666666 dashed;
}

.index_new .news .list .li .left,
.index_new .notice .list .li .left {
  color: #666666;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.index_new .news .list .li .right,
.index_new .notice .list .li .right {
  color: #999999;
}

.index_new .notice .list {
  width: 100%;
  background: #f6f6f6;
}

.index_service {
  margin-top: 60px;
}

.index_service .list {
  justify-content: space-between;
}

.index_service .list .li {
  width: 260px;
  height: 360px;
  position: relative;
}

.index_service .list .li img {
  height: 100%;
  width: 100%;
}

.index_service .list .li p {
  width: 100%;
  height: 60px;
  text-align: center;
  position: absolute;
  line-height: 60px;
  bottom: 0px;
  color: white;
  background-color: rgba(27, 99, 167, 0.5);
}

.business {
  width: 100%;
  height: 390px;
  background: #f7f7f7;
  margin-top: 98px;
}

.business_center {
  width: 1200px;
  margin: 0 auto;
  /*background: red;*/
  align-items: center;
  color: #1b63a7;
}

.business_center .title {
  align-items: center;
  padding-top: 40px;
}

.business_center .line {
  height: 3px;
  width: 50px;
  margin-top: 18px;
  margin-bottom: 16px;
  background: #1b63a7;
}

.business_center .content {
  margin-top: 44px;
}

.business_center .content .left {
  width: 900px;
  border-right: 1px solid #d9d9d9;
  justify-content: space-around;
}

.business_center .content .phone {
  margin-left: 74px;
  font-size: 24px;
  margin-top: 20px;
}

.business_center .content .li {
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 180px;
}

.business_center .content .li:hover {
  background: white;
}

.business_center .content .li p {
  margin-top: 34px;
}

.business_center .content img {
  width: 88px;
  height: auto;
}

.advert {
  width: 100%;
  height: 178px;
  background: #1b63a7;
}

.advert img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.float {
  height: 252px;
  width: 48px;
  position: fixed;
  z-index: 2000;
  top: 200px;
  right: 0px;
  font-size: 12px;
  padding: 0px 10px;
  box-sizing: border-box;
  justify-content: space-around;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  border-left: 1px solid #ededed;
  background: white;
}

.float .li {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #ededed;
  padding: 10px 0px;
  box-sizing: border-box;
}

.float .li:last-child {
  border-bottom: none;
}

.notice_img {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue